import { NvLogin } from '@simwood/nv-react-components-v2';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { restAPIBase } from '../helpers/nvFetch';
import { isElectron } from '../helpers/platform';
import { tokenReceived } from '../reducers/user';
import styles from '../styles/appHelper.scss';
const Login = () => {
    const dispatch = useDispatch();
    const forgotPasswordLocation = useSelector((state) => { var _a; return (_a = state.branding.branding) === null || _a === void 0 ? void 0 : _a.forgotPasswordLocation; });
    const signUpUrl = useSelector((state) => { var _a; return (_a = state.branding.branding) === null || _a === void 0 ? void 0 : _a.signUpUrl; });
    const logoSrc = useSelector((state) => { var _a; return (_a = state.branding) === null || _a === void 0 ? void 0 : _a.partnerLogoSrc; });
    const inverted = useSelector((state) => { var _a; return (_a = state.branding.branding) === null || _a === void 0 ? void 0 : _a.topbarInverted; });
    const loginRedirectUrl = useSelector((state) => { var _a; return (_a = state.branding.branding) === null || _a === void 0 ? void 0 : _a.loginRedirectUrl; });
    const handleSubmit = (accessToken, expires) => {
        dispatch(tokenReceived({ accessToken, expires }));
    };
    return (React.createElement(NvLogin, { className: isElectron() ? styles.desktopLogin : undefined, apiBase: restAPIBase(), localStorageKey: 'nv-communicator', logoSrc: logoSrc, forgotPasswordLink: forgotPasswordLocation, signUpLink: signUpUrl, onToken: handleSubmit, inverted: inverted, loginRedirectUrl: loginRedirectUrl }));
};
export default Login;
